module.exports = __webpack_public_path__ + "img/Invasion-LUCA_10X_LU.0c6e7297.png";